import React from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import { getGroupCommission } from './utils/groupCalculation'; 

const GroupCommission = React.memo(({ positionList, symbolId, side }) => {
    const symbol = useSelector(state => state.watchlist.symbols?.[symbolId]);
    const symbolParam = useSelector(state => state.symbol.allSymbolParams?.[symbolId], shallowEqual);
    const refSymbol = useSelector(state => state.updateSymbol.symbols?.[symbol?.referenceSymbolId]);

    const totalCommission = getGroupCommission({ positionList, symbolParam, symbol, refSymbol, side });

    return <div>{totalCommission.toFixed(2)}</div>;
});
export default GroupCommission;
// const GroupCommission = React.memo(({ positionList, symbolId, side }) => {
//     const symbol = useSelector(state => state.watchlist.symbols?.[symbolId]);
//     const symbolParam = useSelector(state => state.symbol.allSymbolParams?.[symbolId], shallowEqual);
//     const refSymbol = useSelector(state => state.updateSymbol.symbols?.[symbol?.referenceSymbolId]);

//     if (!symbol || !symbol.bid || !symbol.ask || !symbolParam) return <div>0.00</div>;

//     const bid = symbol.bid;
//     const ask = symbol.ask;
//     const price = side === 1 ? bid : ask;

//     const getRefValue = () => {
//         const { referenceSymbolCalculationType } = symbolParam;
//         if (!symbol.referenceSymbolId || !refSymbol) return 1;
//         return referenceSymbolCalculationType === "Division" ? 1 / price : price;
//     };

//     const totalCommission = positionList.reduce((total, pos) => {
//         const { closeCommissionValue, closeCommissionType } = symbolParam;
//         let commission = 0;

//         switch (closeCommissionType) {
//             case 1:
//                 commission = pos.amount * symbol.contractSize * price * 0.01 * closeCommissionValue * getRefValue();
//                 break;
//             case 2:
//                 commission = closeCommissionValue * pos.amount;
//                 break;
//             case 3:
//                 commission = closeCommissionValue;
//                 break;
//             default:
//                 commission = 0;
//         }

//         return total + commission;
//     }, 0);

//     return <div>{totalCommission.toFixed(2)}</div>;
// });

// export default GroupCommission;
